import React, { useEffect, useState } from 'react'
import { Translate } from '../../language';

import Button from '../../utils/components/Button/Button';
import Input from '../../utils/components/Input/Input';
import { formatPrice } from '../../utils/functions';
import localStorage from '../../utils/hooks/useLocalStorage';
import { usePlaces } from '../../utils/hooks/usePlaces';
import "./ShopingBag.css"
const PaymentSummary = ({
    isLoadingPointsToRedeem,
    type,
    deliveryAddress,
    setDeliveryAddress,
    deliveryEntityId,
    setDeliveryEntityId,
    pointsRedem,
    setPointsRedem,
    pointsToRedeem,
    listOfReportsLimit,
    subTotal,
    total,
    pay,
    typeUser,
    disscount,
    isPoints,
    totalPoints,
    typeOfDelivery,
    setTypeOfDelivery,
    wareHausesWinery = [],
    typeOfPay,
    setTypeOfPay,
    country, setCountry, state, setState, city, setCity,location,setLocation,phone, setPhone
}) => {

    const [isEnoughEcopoints, setIsEnoughEcopoints] = useState(false);

    const { countries, states, cities } = usePlaces(country, state)
    //  usePlaces()
    useEffect(() => {
        if (typeOfPay === "ecos") {
            setPointsRedem(subTotal / listOfReportsLimit.ecoPrice);
            if ((pointsToRedeem?.ecoPoints >= pointsRedem)) {
                setIsEnoughEcopoints(true);
            }
            else {
                setIsEnoughEcopoints(false);
            }
        }
        else if (typeOfPay === "combinacion") {

            if ((pointsToRedeem?.ecoPoints >= pointsRedem)) {
                setIsEnoughEcopoints(true);
            }
            else {
                setIsEnoughEcopoints(false);
            }
        }
    }, [pointsRedem, subTotal]);
    return (
        <div className="payment-summary" >
            <div className="parent-width column centerItems centerContent parent-higth">
                <div className=" text-center text-bold color-purple-dark">Resumen de tu orden</div>
            </div>
            <hr />
            <div className="xpayment-summary-body text-center">
                <div className='container-width margin-center'>
                    {
                        !isPoints && (
                            <>
                             <div className='color-purple-dark'>Datos de envío</div>
                            
                            <select className='input-select-style text-center' value={typeOfDelivery} onChange={e => setTypeOfDelivery(e.target.value)}>
                                <option value="">Seleccione tipo de entrega</option>
                                <option value="home">Envío</option>
                                <option value="pickup">Recoger en EcoCeo</option>
                            </select>
                            </>
                        )
                    }

                    {
                        typeOfDelivery === "home" && (
                            <div className='mt-2'>
                                <div className='input-select-style-container'>
                                    <select
                                        className={`input-select-style`}
                                        name="country"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                    >
                                        <option value="">País</option>
                                        {countries.map((country) => (
                                            <option key={country.countryID} value={country.countryName}>
                                                {country.countryName}
                                            </option>
                                        )
                                        )}
                                    </select>

                                </div>
                                <div className='input-select-style-container'>
                                    <select
                                        className={`input-select-style`}
                                        name="state"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                    >
                                        <option value="">Departamento</option>
                                        {states.map((state) => (
                                            <option key={state.stateID} value={state.stateName}>
                                                {state.stateName}
                                            </option>
                                        )
                                        )}
                                    </select>

                                </div>
                                <div className='input-select-style-container'>
                                    <select
                                        className={`input-select-style`}
                                        name="city"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    >
                                        <option value="">Ciudad</option>
                                        {cities.map((city) => (
                                            <option key={city.cityID} value={city.cityName}>
                                                {city.cityName}
                                            </option>
                                        )
                                        )}
                                    </select>

                                </div>
                                <Input
                                    center={true}
                                    value={location}
                                    onChange={e => setLocation(e.target.value)}
                                    placeholder='Barrio'
                                />
                                <Input
                                    center={true}
                                    value={deliveryAddress}
                                    onChange={e => setDeliveryAddress(e.target.value)}
                                    placeholder='Dirección de envío'
                                />
                                <Input
                                    center={true}
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                    placeholder='Teléfono'
                                />
                            </div>
                        )

                    }
                    {
                        typeOfDelivery === "pickup" && (
                            <div className='mt-2'>
                                <select className='input-select-style text-center' value={deliveryEntityId} onChange={e => setDeliveryEntityId(e.target.value)}>
                                    <option value="">Seleccione el EcoCeo</option>
                                    {
                                        wareHausesWinery.map(ww => (
                                            <option value={ww._id} key={ww._id}>{ww.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        )

                    }
                </div>
               
                {
                   (!isPoints &&  localStorage().getItem("typeProfile") !== "warehouse"  &&  localStorage().getItem("typeProfile") !== "franchise") && (
                        <>
                            {isLoadingPointsToRedeem ?
                                <div className='color-purple-dark'>Cargando ...</div> :
                                <div>

                                    <div className='color-purple-dark'>Datos del pago</div>

                                    {
                                        ( localStorage().getItem("typeProfile") !== "warehouse"  ) && (
                                            <select className='input-select-style text-center  container-width margin-center' value={typeOfPay}
                                                onChange={(e) => {
                                                    setTypeOfPay(e.target.value)
                                                    if (e.target.value === "ecos") {
                                                        setPointsRedem(subTotal / listOfReportsLimit.ecoPrice);
                                                    }
                                                    else if (e.target.value === "combinacion") {
                                                        if (pointsToRedeem?.ecoPoints < subTotal / listOfReportsLimit.ecoPrice) {
                                                            setPointsRedem(subTotal / listOfReportsLimit.ecoPrice);
                                                        }
                                                        else {
                                                            setPointsRedem(0);
                                                        }

                                                    }
                                                }}>
                                                <option value="">Seleccione tipo de pago</option>
                                                <option value="pesos">Pesos</option>
                                                <option value="ecos">Ecos</option>
                                                <option value="combinacion">Pesos y ecos</option>
                                            </select>
                                        )}



                                    {
                                        typeOfPay === 'ecos' && (
                                            <div>
                                                <div className='mt-1'><span className='text-color-green'>Valor del Eco: </span> {listOfReportsLimit.ecoPrice}</div>
                                                <div className='mt-1'><span className='text-color-green'>Puntos para redimir: </span> {pointsToRedeem?.ecoPoints}</div>
                                                {isEnoughEcopoints ?
                                                    <div className='mt-2'>
                                                        <span className='text-color-green'>Gastarás </span>
                                                        {pointsRedem}
                                                        <span className='text-color-green'> ecos, </span>
                                                        <span className='text-color-green mt-1'>equivalentes a: </span>
                                                        <span className=''>
                                                            {formatPrice(pointsRedem * listOfReportsLimit.ecoPrice)}
                                                        </span>

                                                    </div> :
                                                    <div className='text-error mt-1'>No tienes suficientes Ecos, selecciona otra forma de pago</div>}

                                            </div>
                                        )
                                    }
                                    {
                                        typeOfPay === 'combinacion' && (
                                            <div>
                                                <div className='mt-1'><span className='text-color-green'>Valor del Eco: </span> {listOfReportsLimit.ecoPrice}</div>
                                                <div className='mt-1'><span className='text-color-green'>Puntos para redimir: </span> {pointsToRedeem?.ecoPoints}</div>
                                                <div className='mt-2'>
                                                    <div>
                                                        <span className='text-color-green'>Puntos para usar: </span>
                                                        <Input
                                                            classNameContent='fit-content-width display-inline'
                                                            classNameInput='fit-content-width display-inline'
                                                            placeholder='Puntos para pagar'
                                                            type='number'
                                                            min={0}
                                                            max={pointsToRedeem?.ecoPoints}
                                                            value={pointsRedem}
                                                            onChange={e => {
                                                                if (pointsToRedeem?.ecoPoints >= e.target.value)
                                                                    setPointsRedem(e.target.value)
                                                                else {
                                                                    setPointsRedem(pointsToRedeem?.ecoPoints)
                                                                }

                                                            }
                                                            }
                                                        />
                                                    </div>

                                                    <span className='text-color-green'>Gastarás </span>
                                                    {pointsRedem}
                                                    <span className='text-color-green'> ecos, </span>
                                                    <span className='text-color-green mt-1'>equivalentes a: </span>
                                                    <span className=''>
                                                        {formatPrice(pointsRedem * listOfReportsLimit.ecoPrice)}
                                                    </span>
                                                    <div>
                                                        <span className='text-color-green mt-4'>Valor en pesos a pagar : </span>
                                                        {formatPrice(subTotal - (pointsRedem * listOfReportsLimit.ecoPrice))}
                                                    </div>

                                                </div>

                                            </div>
                                        )
                                    }
                                </div>
                            }

                        </>
                    )
                }
                {
                    isPoints ? <>
                        <div>
                            Total de EcoPuntos {totalPoints}
                        </div>
                        Valor total al pagar: {formatPrice(subTotal)}
                    </> : <>
                        {typeUser.length > 0 ? //Si es ecotienda o representante se le aplica un descuento
                            <>
                                <div>
                                    <span className='text-color-green'>Sub-total de productos  </span><span className='price'>{formatPrice(subTotal)}</span>
                                </div>
                                <div>
                                    Tu descuento por ser  {typeUser.map(type => Translate(type, 'es')).join(" y ")}  es {(disscount) * 100}%
                                </div>
                                <div>
                                    <span className='text-color-green'>Valor total al pagar: </span> <span className='price'>{formatPrice(total)}</span>
                                </div>
                            </> :
                            <div>
                                <span className='text-color-green'>Valor total al pagar: </span> {formatPrice(subTotal)}
                            </div>
                        }
                    </>
                }


                <div>
                    <Button
                        disabled={
                            (typeOfPay === "pesos" && subTotal === 0) ||
                            (typeOfPay === "ecos" && !isEnoughEcopoints) ||
                            ((type === "user" ||
                                type === "re") && ((typeOfDelivery.length === 0) ||
                                    (typeOfDelivery === "home" && country.length && state.length && city.length && deliveryAddress === 0) ||
                                    (typeOfDelivery === "pickup" && deliveryEntityId.length === 0) ||
                                    (typeOfPay === '')))}
                        onClick={pay}
                        text='Finalizar compra'
                    />
                </div>
            </div>
        </div>
    )
}

export default PaymentSummary
